import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    InputNumber,
    Button,
    Select,
    DatePicker,
    Typography,
    Checkbox,
    Input,
    Radio,
    Divider,
    message
} from 'antd';
import moment from 'moment';
import {anyNull, isNull} from "../stores/Util";

const {TextArea} = Input;
const {RangePicker, MonthPicker} = DatePicker;
const {Option} = Select;
const {Text} = Typography;

export default class DynamicForm extends Component {
    state = {};

    render() {
        return (
            <div style={styles.container}>
                {this.renderForm()}
                <div style={styles.submitBtn}>{this.renderButtons()}</div>
            </div>
        );
    }

    renderButtons = () => {
        if (!this.props.showSubmitButton) return null;
        return (
            <Button
                type="primary"
                onClick={this.onSubmit}
                {...this.props.submitButtonProps}>
                {this.props.submitButtonText}
            </Button>
        );
    };

    renderForm = () => {
        return this.props.items.map((props, index) => (
            <div key={`${index}`} style={styles.formItemContainer}>
                <div style={styles.column}>
                    <Text style={styles.label}>{`${props.label} ${props.required ? '(Required)' : ''}`}</Text>
                </div>

                <div style={styles.column}>{this.renderFormItem(props)}</div>
            </div>
        ));
    };

    renderFormItem = props => {
        const {type} = props;
        switch (type) {
            case 'number':
                return this.renderInputNumber(props);
            case 'date':
                return this.renderDatePicker(props);
            case 'daterange':
                return this.renderDateRangePicker(props);
            case 'dropdown':
                return this.renderSelect(props);
            case 'checkbox':
                return this.renderCheckBox(props);
            case 'monthpicker':
                return this.renderMonthPicker(props);
            case 'text':
                return this.renderTextField(props);
            case 'textarea':
                return this.renderTextAreaField(props);
            case 'plaintext':
                return this.renderPlainText(props);
            case 'binary_dropdown':
                return this.renderBinaryDropdown(props);
            case 'divider':
                return <Divider/>;
        }
    };

    renderInputNumber = props => {
        const {defaultValue, key, disabled} = props;
        const value = this.state[key] || defaultValue;
        const onChange = value => this.changeValue(key, value);
        return <InputNumber style={{flex: 1}} key={key} value={value} disabled={disabled} onChange={onChange}/>;
    };

    renderDatePicker = props => {
        const {defaultValue, key, disabled, dateFormat, style} = props;
        let defaultDate = defaultValue ? moment(defaultValue) : null;
        let selectedDate = this.state[key] ? moment(this.state[key]) : null;
        let value = selectedDate || defaultDate;
        const onChange = value => {
            const formattedValue = value.format(dateFormat);
            this.changeValue(key, formattedValue);
        };
        return <DatePicker value={value} onChange={onChange} disabled={disabled} style={{width: '100%', ...style}}/>;
    };

    renderDateRangePicker = props => {
        const {
            fromDateDefaultValue,
            toDateDefaultValue,
            fromDateKey,
            toDateKey,
            disabled,
            dateFormat,
        } = props;
        const startDateValue = moment(this.state[fromDateKey] || fromDateDefaultValue);
        const endDateValue = moment(this.state[toDateKey] || toDateDefaultValue);
        const value = [startDateValue, endDateValue];
        const onChange = values => {
            this.changeValue(fromDateKey, values[0].format(dateFormat));
            this.changeValue(toDateKey, values[1].format(dateFormat));
        };
        return <RangePicker value={value} onChange={onChange} disabled={disabled}/>;
    };

    renderSelect = props => {
        const {options = [], disabled, defaultValue, key, onChange, multiple, style} = props;
        const value = this.state[key] || defaultValue;
        const _onChange = value => {
            onChange && onChange(value);
            this.changeValue(key, value);
        };
        const mode = multiple ? 'multiple' : 'default';
        return (
            <Select
                mode={mode}
                defaultActiveFirstOption={false}
                onChange={_onChange}
                value={value}
                showSearch={true}
                disabled={disabled}
                placeholder={'Select'}
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                style={{width: '100%', ...style}}
            >
                {options.map(item => (
                    <Option key={item.value} value={item.value}>
                        {item.label}
                    </Option>
                ))}
            </Select>
        );
    };

    renderCheckBox = props => {
        const {disabled, defaultValue, key} = props;
        const onChange = e => {
            let value = e.target.checked;
            this.changeValue(key, value);
        };
        const checked = this.state[key] || defaultValue;
        return <Checkbox disabled={disabled} checked={checked} onChange={onChange}/>;
    };

    changeValue = (key, value) => {
        this.setState(state => {
            const newState = {...state};
            newState[key] = value;
            return newState;
        });
    };

    renderMonthPicker = props => {
        const {disabled, defaultValue, monthKey, yearKey} = props;
        const onChange = value => {
            const [month, year] = [value.month() + 1, value.year()];

            this.changeValue(monthKey, month);
            this.changeValue(yearKey, year);
        };

        return <MonthPicker disabled={disabled} defaultValue={defaultValue} onChange={onChange}/>;
    };

    renderTextField = props => {
        const {key, disabled, defaultValue} = props;

        if (disabled) return this.renderPlainText(props);

        const value = isNull(this.state[key]) ? defaultValue : this.state[key];
        const onChange = e => {
            const value = e.target.value;
            this.changeValue(key, value);
        };
        return (
            <Input
                disabled={disabled}
                onChange={onChange}
                value={value}
            />
        );
    }

    renderTextAreaField = props => {
        const {key, disabled, defaultValue} = props;
        const value = isNull(this.state[key]) ? defaultValue : this.state[key];
        const onChange = e => {
            const value = e.target.value;
            this.changeValue(key, value);
        };
        return (
            <TextArea
                disabled={disabled}
                onChange={onChange}
                value={value}
            />
        );
    }

    renderPlainText = props => {
        let defaultValue = props.defaultValue || '';
        defaultValue = `${defaultValue}`;
        let para = defaultValue.split('\n').filter(a => a != '').join('</p><p>');
        para = `<p>${para}</p>`
        return <div style={styles.border} dangerouslySetInnerHTML={{__html: para}}/>;
    };

    renderBinaryDropdown = props => {
        const {key, disabled, defaultValue, style} = props;
        const value = this.state[key] == undefined ? defaultValue : this.state[key];
        const onChange = e => {
            this.changeValue(key, e.target.value);
        };

        return (
            <Radio.Group onChange={onChange} value={value} disabled={disabled} style={style}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
            </Radio.Group>
        );
    }

    onSubmit = () => {
        const {state} = this;
        let valid = true;

        if (this.props.strictValidation) {
            for (let item of this.props.items) {
                if (item.required && anyNull(state[item.key])) {
                    message.warn(`Please enter a value for ${item.label}`);
                    valid = false;
                    break;
                }
            }
        }

        valid && this.props.onSubmit && this.props.onSubmit(this.state);
    }
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    submitBtn: {
        display: 'flex',
        alignSelf: 'flex-end',
    },
    formItemContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'space-between',
        padding: 10,
    },
    label: {
        fontWeight: 'bold',
        paddingRight: 15,
    },
    column: {
        display: 'flex',
        flex: 1,
    },
    border: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        border: '1px solid #d9d9d9',
        borderRadius: 4,
        padding: 10,

    }
};

DynamicForm.defaultProps = {
    onSubmit: () => {
    },
    submitButtonText: 'Submit'
};

const componentTypes = [
    'number',
    'date',
    'daterange',
    'dropdown',
    'checkbox',
    'monthpicker',
    'text',
    'textarea',
    'plaintext',
    'divider',
    'binary_dropdown'
];
DynamicForm.propTypes = {
    // the list of items to render
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            type: PropTypes.oneOf(componentTypes).isRequired,
            defaultValue: PropTypes.any,
            initialValue: PropTypes.any,
            disabled: PropTypes.bool,
            label: PropTypes.string.isRequired,
            required: PropTypes.bool,

            // date specific properties
            dateFormat: PropTypes.string,

            // daterange specific properties
            fromDateKey: PropTypes.string,
            toDateKey: PropTypes.string,

            // dropdown specific properties
            options: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.any,
                    value: PropTypes.any,
                }).isRequired,
            ),
            onChange: PropTypes.func,
            multiple: PropTypes.bool,

            // month picker specific properties
            monthKey: PropTypes.string,
            yearKey: PropTypes.string,
        }),
    ),
    onSubmit: PropTypes.func.isRequired,
    showSubmitButton: PropTypes.bool,
    submitButtonText: PropTypes.string,
    submitButtonProps: PropTypes.object,
    strictValidation: PropTypes.bool
};

DynamicForm.defaultProps = {
    showSubmitButton: true,
    submitButtonProps: {},
    strictValidation: true
};

export const deafaultDateRange = {
    type: 'daterange',
    key: '',
    label: 'Date Range',
    fromDateKey: 'fromDate',
    toDateKey: 'toDate',
    dateFormat: 'DD-MMM-YYYY',
};
